<template>
  <footer class="text-center">
    <small>©2025 StudioJambo</small>
  </footer>
</template>
<script>
export default {
  name: "MainFooter",
};
</script>
